import(/* webpackMode: "eager" */ "/app/src/app/(website)/[locale]/loading.tsx");
